import React, { FC, useEffect, useState } from 'react';

import { map, slice } from 'lodash';
import { useSelector } from 'react-redux';
import { customTheme } from 'theme';

import { selectActiveResource } from 'containers/ActiveCloudResource/selectors';

import { Breakdown } from './Breakdown';

export const DistributionByDocumentType: FC = () => {
  const { data } = useSelector(selectActiveResource);
  const { data: labels, isLoading } = data.distributionByDocumentType;
  const [chartData, setChartData] = useState<Record<string, any>[]>([]);

  useEffect(() => {
    //const other = sum(map(slice(labels, 5, labels?.length), o => o.count));
    setChartData(
      map(slice(labels, 0, 5), o => ({
        name: o.type_name,
        value: o.count ?? 0,
        percent: o.percentage ?? 0,
      })),
    );
  }, [labels]);

  const colorMap = {
    'Table format': customTheme.colors.blue['300'],
    Documents: customTheme.colors.skyBlue['300'],
    Images: customTheme.colors.primary,
    Archive: customTheme.colors.green['300'],
    Other: customTheme.colors.orange['300'],
  };

  return (
    <Breakdown
      data={chartData}
      isLoading={isLoading}
      label="Distribution by types of documents"
      colorMap={colorMap}
    />
  );
};
